
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Crime = () => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    // Define default static data matching the backend structure (assuming similar to Country/Politics)
    const defaultData = {
        main_news: {
            featured: {
                title: "अपराध",
                category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
                date: "2017-03-22T17:49",
                // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
                image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
            },
            list: [
                {
                    title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
                    // image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
                    category: "News",
                    date: "2017-03-22T17:50",
                    description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
                },
                {
                    title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
                    image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
                },
                {
                    title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
                    // image: "/assets/img/11-1_1759952360.webp",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
                }
            ]
        },
        sidebar: {
            // social_links: [
            //     { platform: "facebook", icon: "fa fa-facebook", follows: "50k" },
            //     { platform: "instagram", icon: "fa fa-instagram", follows: "10k" },
            //     { platform: "youtube", icon: "fa fa-youtube", follows: "25k" },
            //     { platform: "twitter", icon: "fa fa-twitter", follows: "20k" }
            // ],
            weather: {
                location: "Panna, IN",
                time: "6:03 pm, Oct 7, 2025",
                temperature: "42",
                condition: "19°C",
                // image: "/assets/img/rain-6243559_1280.jpg"
                image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688160/rain-6243559_1280_wu1xxh.jpg"
            },
            recent_news: [
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Someone Has Cal The Total Cost", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" }
            ]
        }
    };

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            try {
                console.log("Fetching crime data...");
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/crime/all`);
                console.log("res: crime : ", res, res.data)
                if (!mounted) return;
                const fetchedData = res.data.data[0] || defaultData;
                console.log("Fetched crime data:", fetchedData);
                setData(fetchedData);
            } catch (err) {
                console.error("Error fetching crime:", err);
                setData(defaultData);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetchData();
        return () => {
            mounted = false;
        };
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <section className="section-space-bottom-less30 mt-lg-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-12 mb-30">
                            <div className="topic-border color-cod-gray mb-30">
                                <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
                            </div>
                            <div className="img-overlay-70 img-scale-animate">
                                <img src={data.main_news?.featured?.image} alt="news" className="img-fluid" />
                                <div className="mask-content-lg">
                                    <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
                                    <div className="post-date-light">
                                        <ul>
                                            <li>
                                                <span>
                                                    <i className="fa fa-calendar" style={{ color: "white" }} aria-hidden="true" />
                                                </span>{new Date(data.main_news?.featured?.date).toLocaleDateString()}
                                            </li>

                                            <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "white" }} />
                                            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                                            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                                        </ul>
                                    </div>
                                    <h2 className="title-medium-light size-xl d-none d-sm-block">
                                        <Link to="/news-info">{data.main_news?.featured?.category}</Link>
                                    </h2>
                                </div>
                            </div>
                            <div className="item-box-light-md-less30 ie-full-width">
                                {data.main_news?.list?.map((item, index) => (
                                    <div key={index} className="media mb-30 media-none--sm">
                                        <div className="position-relative width-40">
                                            <Link to="/news-info" className="img-opacity-hover">
                                                <img src={item.image} alt="news" className="img-fluid" />
                                            </Link>
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
                                            </div>
                                        </div>
                                        <div className="media-body p-mb-none-child media-margin30">
                                            <div className="post-date-dark">
                                                <ul>
                                                    <li>
                                                        <span>
                                                            <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
                                                        </span>{new Date(item.date).toLocaleDateString()}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black" }} />
                                                    </li>
                                                    <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                                    <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                                </ul>
                                            </div>
                                            <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
                                                <Link to="/news-info">{item.title}</Link>
                                            </h3>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
                            <div className="sidebar-box">
                                {/* <div className="topic-border color-cod-gray mb-30">
                                    <div className="topic-box-lg color-cod-gray">Stay Connected</div>
                                </div> */}
                                <ul className="stay-connected-light overflow-hidden mb-20">
                                    {data.sidebar?.social_links?.map((link, index) => (
                                        <li key={index} className={link.platform}>
                                            <Link to="#">
                                                {link.icon.startsWith('http') || link.icon.startsWith('/') ? (
                                                    <img src={link.icon} alt={link.platform} style={{ width: '20px', height: '20px' }} />
                                                ) : (
                                                    <i className={link.icon} aria-hidden="true" />
                                                )}
                                                <div className="connection-quantity">{link.follows}</div>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="sidebar-box">
                                <div className="topic-border color-cod-gray">
                                    <div className="topic-box-lg color-cod-gray">राशिफल</div>
                                </div>
                                <br />

                                <div id="text-11" className="container-wrapper widget widget_text">
                                    <div className="textwidget">
                                        <div style={{ height: 300 }}>
                                            <iframe src="https://piushtrivedi.neocities.org/hindi_astrology_google_gadget_part_1_updated_html2.html" width="100%" height="100%" frameBorder={0} scrolling="no" />
                                        </div>
                                    </div>
                                    <div className="clearfix" />
                                </div>
                                {/* <div className="img-overlay-70 img-scale-animate">
                                    <img src={data.sidebar?.weather?.image} alt="news" className="img-fluid" />
                                    <div className="mask-content-lg">
                                        <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">{data.sidebar?.weather?.location}</div>
                                        <div className="post-date-light">
                                            <ul>
                                                <li style={{ fontSize: "18px" }}>
                                                    <span>
                                                        <i className="fa fa-clock-o" aria-hidden="true" />
                                                    </span>{data.sidebar?.weather?.time}
                                                </li>
                                            </ul>
                                        </div>
                                        <h2 className="title-medium-light size-xl d-none d-sm-block">
                                            <p>{data.sidebar?.weather?.condition}</p>
                                        </h2>
                                    </div>
                                </div> */}
                            </div>
                            <div className="sidebar-box">
                                <div className="topic-border color-cod-gray">
                                    <div className="topic-box-lg color-cod-gray">Recent News</div>
                                </div>
                                <div className="row">
                                    {data.sidebar?.recent_news?.map((news, index) => (
                                        <div key={index} className="col-lg-6 col-md-4 col-sm-6 col-6 mt-30">
                                            <div className="item-shadow-gray">
                                                <div className="position-relative">
                                                    <div className="topic-box-top-xs">
                                                        <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                                    </div>
                                                    <Link to="/news-info" className="img-opacity-hover">
                                                        <img src={news.image} alt="news" className="img-fluid" />
                                                    </Link>
                                                </div>
                                                <div className="box-padding15 bg-body item-shadow-gray">
                                                    <h3 className="title-medium-dark size-sm mb-10">
                                                        <Link to="/news-info">{news.title}</Link>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Crime;
